
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.47 16.51"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Union 13","d":"M6.092 16.51H2.36a.882.882 0 01-.8-.943L.475 4.724a.882.882 0 01.8-.943h9.913a.882.882 0 01.8.943l-1.074 10.843a.882.882 0 01-.8.943zm0-13.9H0c0-.639.714-1.158 1.595-1.158h9.281c.881 0 1.594.519 1.594 1.158zm0-1.737H4.551c0-.482.273-.873.609-.873h2.15c.337 0 .609.391.609.875z"}})])
          )
        }
      }
    